import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
} from '@angular/common/http';
import { TokenStorage } from './token-storage';
const TOKEN_HEADER_KEY = 'Authorization';


export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
 const token = inject(TokenStorage);
  let lang = '';
    let userSettings = window.localStorage.getItem('userSettings');
    if (userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      lang = userSettingParsed.lang;
    } else {
      lang = 'en'
    }
    //Changed by Abirami on 11th May 2023 - They removed the validation for client info and fingerprint at backend 
    //IP Address fetch is taking time and finger print should be licensed version if we are using
    if (token.get()) {
      const headers = req.headers
      .set(TOKEN_HEADER_KEY, 'Bearer ' + token.get());
        // .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb") //This is currently not in use and commented on 30th March by Abirami
        // .append('clientInfo', JSON.stringify(clientInfo))
        //.append(TOKEN_HEADER_KEY, 'Bearer ' + this.token.get());
      const requestClone = req.clone({
        headers,
      });
      return next(requestClone);
    } 
    // else if (this.token.getCT()) {
    //   const headers = req.headers
    //   .set(TOKEN_HEADER_KEY, 'Bearer ' + this.token.getCT());
    //     // .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb") //This is currently not in use and commented on 30th March by Abirami
    //     // .append('clientInfo', JSON.stringify(clientInfo))
    //     //.append(TOKEN_HEADER_KEY, 'Bearer ' + this.token.get());
    //   const requestClone = req.clone({
    //     headers,
    //   });
    //   return next.handle(requestClone);
    // } 
    else {
      // const headers = req.headers
      //   .set('fingerprint', "RFzuSZGSmX0cpYW8PAJb")
      //   .append('clientInfo', JSON.stringify(clientInfo)) //This is currently not in use and commented on 30th March by Abirami
      const requestClone = req.clone({});
      return next(requestClone);
    }
};